import { render, staticRenderFns } from "./OrgLimitManaged.vue?vue&type=template&id=38794e5b&"
import script from "./OrgLimitManaged.vue?vue&type=script&lang=js&"
export * from "./OrgLimitManaged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports